import type { BrokerStatus as Status } from "@trader/shared/BrokersApi"
import { useCallback, useEffect, useState } from "react"
import { call } from "../../api.ts"

const POLL_MS = 60_000

const timeLeft = (expiresAt: number) => {
  const minutes = Math.max(0, Math.round((expiresAt - Date.now() / 1000) / 60))
  return minutes >= 60 ? `${Math.floor(minutes / 60)}h ${minutes % 60}m` : `${minutes}m`
}

/** Fyers connection state, and the button to (re)connect, which Fyers requires daily. */
export function BrokerStatus() {
  const [status, setStatus] = useState<Status | null>(null)
  const [error, setError] = useState<string | null>(null)

  const refresh = useCallback(() => {
    call((client) => client.brokers.status()).then((all) => setStatus(all[0] ?? null), () => setStatus(null))
  }, [])

  useEffect(() => {
    refresh()
    const timer = setInterval(refresh, POLL_MS)
    return () => clearInterval(timer)
  }, [refresh])

  const connect = async () => {
    setError(null)
    try {
      const { url } = await call((client) => client.brokers.connectFyers())
      window.location.assign(url)
    } catch {
      setError("Couldn't start the Fyers login.")
    }
  }

  if (status === null) return null
  if (!status.configured) return <span className="broker broker-off" title="Set FYERS_APP_ID and FYERS_SECRET_KEY on the server">Fyers: not configured</span>

  return (
    <span className={status.connected ? "broker broker-on" : "broker broker-off"}>
      {status.connected && status.expiresAt !== null
        ? <span title={`Token expires in ${timeLeft(status.expiresAt)}`}>Fyers · {status.accountName ?? "connected"}</span>
        : <span>Fyers: not connected</span>}
      {!status.connected && <button type="button" onClick={connect}>Connect</button>}
      {error && <span className="broker-error">{error}</span>}
    </span>
  )
}
